// Import Firebase Configuration file
import { initializeApp } from "firebase/app"
import { getMessaging } from "firebase/messaging"

const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENTID,
}

const hasRequiredFirebaseConfig = Boolean(
  firebaseConfig.apiKey &&
    firebaseConfig.projectId &&
    firebaseConfig.messagingSenderId &&
    firebaseConfig.appId,
)

let app = null
let messaging = null

if (hasRequiredFirebaseConfig) {
  try {
    app = initializeApp(firebaseConfig)
    messaging = getMessaging(app)
  } catch (error) {
    // Avoid crashing the whole app if Firebase config is invalid.
    // eslint-disable-next-line no-console
    console.warn("Firebase failed to initialize:", error)
  }
} else {
  // eslint-disable-next-line no-console
  console.warn(
    "Firebase messaging disabled: missing REACT_APP_* config. Restart npm start after updating .env.",
  )
}

export { messaging, app }
